import { render, staticRenderFns } from "./bidDocument.vue?vue&type=template&id=533856ee"
import script from "./bidDocument.vue?vue&type=script&lang=js"
export * from "./bidDocument.vue?vue&type=script&lang=js"
import style0 from "./bidDocument.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports